import React, { ReactElement } from 'react';
import { Contact } from '../../../shared/schema/ContactSchema';
import { Customer } from '../../../shared/schema/CustomerSchema';
import { uploadedImageDir } from '../../../utils/configs';

import './CustomerCard.scss';

interface CustomerCardProps {
  customer: Customer;
  contacts: Contact[];
}

export default function CustomerCard(props: CustomerCardProps): ReactElement {
  const { customer, contacts } = props;
  let contact = null;

  if (contacts?.length > 0) {
    contact = contacts[0];
  }

  let imgSrc = null;
  if (customer.logoPath) {
    imgSrc = `${uploadedImageDir}/${customer.logoPath}`;
  }
  return (
    <div className="customerCard">
      <h3>
        <b>{customer.businessName}</b>
      </h3>

      <div className="smallSeparator" />
      <div style={{ height: '1em' }} />
      <div style={{ display: 'flex', marginBottom: '1.5em', minHeight: 85 }}>
        {imgSrc && (
          <img
            className="p-grid-image"
            src={imgSrc}
            alt={imgSrc.split('/').pop()}
          />
        )}

        {customer.url && (
          <div style={{ width: '100%', position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                width: '100%',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              {contact && (
                <>
                  <p>
                    <b>Ansprechpartner</b>
                  </p>

                  <div>
                    <p>{contact.name}</p>
                    <a href={`tel:${contact.phone1}`}>{contact.phone1}</a>
                  </div>
                </>
              )}
              <p>
                <b>Weitere Projekte</b>
              </p>
              <a href={`/bautraeger/${customer.url}`}>
                Hier klicken und alle Projekte anzeigen
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
